import React from 'react'

import { DatePicker, Space } from 'antd';

const { RangePicker } = DatePicker;



class DateRangeSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: moment().subtract(2, 'year'),
      endDate: moment(),
      // focusedInput: 'startDate'
    }

  }

  onChange = (dates) => {

    const [startDate, endDate] = dates
    // this.setState({ startDate, endDate })
    // window[this.props.callback](from == null ? null : from.format('L'), to.format('L'));

    const {copyToDOMId, onChange} = this.props
    if (onChange) onChange(startDate, endDate)

    if (copyToDOMId){
      document.getElementById(copyToDOMId).value = startDate?.format('L') + '||' + endDate?.format('L') 
    }

  }

  render() {

    return (

      <RangePicker

        onChange={this.onChange}
      />

    )

  }

}

DateRangeSelector.defaultProps = {
  startDateInputId: 'start-date-field',
  endDateInputId: 'end-date-field',
}

export default DateRangeSelector

